// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"93":"list","180":"story"}[chunkId] + "-" + {"93":"9304d6510fb684cc8899","180":"a062d137b2cd88ee58cc"}[chunkId] + ".css";
};